module.exports = __webpack_public_path__ + "static/img/2caca.3901cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/2caca.png
// module id = 228
// module chunks = 1